
import { Component, Vue, Watch, Prop, Emit } from "vue-property-decorator"
import { namespace, Getter, Mutation, Action } from "vuex-class"

// @ts-ignore
import VuePerfectScrollbar from "vue-perfect-scrollbar"
import { Case, CaseDetails, CaseSummary, Field, TimeZone } from "@/types"

import SkeletonLoader from "../SkeletonLoader.vue"
import CaseList from "@/components/CaseList/CaseList.vue"
import CalendarView from "@/components/Config/Schedules/CalendarView.vue"
import ScheduleInstance from "@/components/Config/Schedules/ScheduleInstance.vue"

import vSelect from "vue-select"

import api from "@/services/api"
import { Schedule } from "@/types/schedule"
import { cases } from "@/store/cases"

const caseStore = namespace("cases")
const setup = namespace("setup")

@Component({
	components: {
		"scrollbar": VuePerfectScrollbar,
		"calendar": CalendarView,
		"skeleton": SkeletonLoader,
		"schedule-popup": ScheduleInstance,
		"v-select": vSelect
	}
})
export default class DashboardCalendar extends Vue {
	@Prop()
	value: any;

	@Prop()
	edit!: boolean

	private schedules: Schedule[] = []
	private records: CaseSummary[] = []

	views: any[] = [];

	activeView: any = null;
	loadingCases: boolean = true;
	errorLoading: boolean = false;
	displayRecords: Case[] = [];
	private timeZones: TimeZone[] = []

	viewScheduleInstance: {
		schedule: Schedule,
		date: Date
	} | null = null

	public async mounted () {
		this.onEditChanged()

		api.timeZonesGet().then(timeZones => this.timeZones = timeZones)
	}

	public async rowClick (item: any) {
		this.$router.push({ path: `/cases/${item.caseNumber}` })
	}

	@Watch("edit")
	private async onEditChanged () {
		if (!this.edit) {
			this.loadingCases = true
			this.errorLoading = false

			try {
				this.schedules = await api.retrieveSchedules()
			} catch (err) {
				this.errorLoading = true
				console.error(err)
			}

			this.loadingCases = false
		}
	}

	private async calendarRangeChanged ({ start, end }: { start: Date, end: Date }) {
		this.records = await api.casesBetween(start, end)
	}

	recordClicked (caseSummary: CaseSummary) {
		this.$emit("showCase", caseSummary, (updatedCase: CaseSummary) => {
			console.log(updatedCase)

			caseSummary.title = updatedCase.title
			caseSummary.closed = updatedCase.closed
		})
	}

	openScheduleInstance (schedule: Schedule, instanceDate: Date) {
		this.viewScheduleInstance = {
			schedule,
			date: instanceDate
		}
	}

	scheduleUpdated (schedule: Schedule) {
		const existingIndex = this.schedules.findIndex(s => s.id === schedule.id)
		if (existingIndex > -1) {
			this.schedules.splice(existingIndex, 1, schedule)
		}
	}
}
